import { createActions } from 'redux-actions';
import { request } from '../../services';

export const showHistoryScreen = rate => (
  { type: 'SHOW_RATE_HISTORY', payload: { rate } }
);

export const hideHistoryScreen = () => ({ type: 'HIDE_RATE_HISTORY' });

const {
  payRateListRequest,
  payRateListSuccess,
  payRateListFailure,
} = createActions({
  PAY_RATE_LIST_SUCCESS: [
    json => json,
    (json, rate) => ({ rate }),
  ],
}, 'PAY_RATE_LIST_REQUEST', 'PAY_RATE_LIST_FAILURE');

export function requestPayRatesList(id, rate) {
  return (dispatch) => {
    dispatch(payRateListRequest());

    return request(`estimators/${id}/pay_rate_history/${rate}`)
      .then(({ json }) => (
        dispatch(payRateListSuccess(json, rate))
      ),
      (error) => {
        dispatch(payRateListFailure(error));
      });
  };
}



// WEBPACK FOOTER //
// ./client/app/shared/actionCreators/pay_rates.js